import { Navigate } from "react-router-dom";
import ContactHeader from "./ContactHeader";
import Navbar from "./Navbar";
import Layout from "./Layout";

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  // Simulated authentication function
  const isAuthenticated = () => {
    return localStorage.getItem("authToken") !== null;
  };
  return isAuthenticated() ? (
    <>
      <div className="fixed top-0 left-0 w-full z-50 bg-white shadow-md">
        <ContactHeader />
        <Navbar />
      </div>
      <Layout>{children}</Layout>
    </>
  ) : (
    <Navigate to="/login" replace />
  );
};

export default ProtectedRoute;
